import { ActionId } from './actionId';
import { setAnimationAction } from '../actions/setAnimationAction';

export function startAnimatedAction(
    actionId: ActionId,
    rowKeys: string[],
    handleAnimation?: () => void
) {
    setAnimationAction(actionId /*actionId*/, rowKeys, handleAnimation);
}
